<oui-error-page pageTitle="Une erreur est survenue lors du traitement de votre requête.">
  <p>Veuillez rafraîchir la page et contacter l'administrateur si l'erreur persiste.</p>

  <div class="actions-container">
    <oui-button
      size="large"
      iconSuffix="autorenew"
      (click)="reloadPage()"
      >Recharger la page
    </oui-button>
  </div>
</oui-error-page>
